export default __webpack_public_path__ + "static/media/B142.990ea876.png";